export const categories = [
  {
    id: 'personal',
    name: '个人资料',
    slug: 'personal',
    description: '全面了解吉泽明步的基本信息、身体数据、兴趣爱好等个人档案资料。',
    icon: 'ri-user-heart-line',
    color: 'accent',
  },
  {
    id: 'career',
    name: '演艺经历',
    slug: 'career',
    description: '回顾吉泽明步从出道至今的完整演艺生涯，涵盖重要节点与里程碑事件。',
    icon: 'ri-movie-line',
    color: 'primary',
  },
  {
    id: 'works',
    name: '代表作品',
    slug: 'works',
    description: '盘点吉泽明步最具代表性的经典作品，包含影片介绍与推荐指南。',
    icon: 'ri-star-line',
    color: 'accent',
  },
  {
    id: 'news',
    name: '最新动态',
    slug: 'news',
    description: '追踪吉泽明步的最新消息、活动动态、社交媒体更新与行业资讯。',
    icon: 'ri-flashlight-line',
    color: 'primary',
  },
  {
    id: 'community',
    name: '粉丝社区',
    slug: 'community',
    description: '吉泽明步粉丝交流天地，包含粉丝活动、应援信息与互动分享内容。',
    icon: 'ri-group-line',
    color: 'accent',
  },
];